import classnames from "classnames";
import styles from "./styles/slider.module.scss";
import { Box, Button } from "@mui/material";
import useSlider from "hooks/useSlider";
import { useConsole } from "contexts";
import { Image } from "ui";

export function Highlights({ slides }) {
  const { currentIndex, updateSlider } = useSlider(slides);
  const { screen } = useConsole();

  if (screen.isMobile) return null;

  return (
    <Box className={styles.slider}>
      <Box
        className={styles.slides}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {slides.map((name, index) => (
          <Box
            key={index}
            className={classnames(styles.slide, {
              [styles.active]: index === currentIndex,
            })}
            style={{
              transform: `translateX(${(index - currentIndex) * 100}%)`,
            }}
          >
            <Image
              alt={name}
              height={360}
              loading="lazy"
              src={`/stories/${name}.webp`}
              width={840}
            />
          </Box>
        ))}
      </Box>
      <Button
        className={classnames(styles.navButton, styles.prev)}
        onClick={() => updateSlider(currentIndex - 1)}
      >
        &#10094;
      </Button>
      <Button
        className={classnames(styles.navButton, styles.next)}
        onClick={() => updateSlider(currentIndex + 1)}
      >
        &#10095;
      </Button>
      <Box className={styles.indicators}>
        {slides.map((_, index) => (
          <Box
            key={index}
            className={classnames(styles.indicator, {
              [styles.active]: currentIndex === index,
            })}
            onClick={() => updateSlider(index)}
          ></Box>
        ))}
      </Box>
    </Box>
  );
}
